var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.2 7.227c.26 0 .467-.207.467-.467v-.62c0-2.733-.833-3.567-3.566-3.567H4.9c-2.734 0-3.567.834-3.567 3.567v.313c0 .26.207.467.467.467.6 0 1.086.487 1.086 1.087s-.486 1.08-1.086 1.08a.464.464 0 0 0-.467.466v.314c0 2.733.833 3.566 3.567 3.566h6.2c2.733 0 3.566-.833 3.566-3.566a.464.464 0 0 0-.466-.467 1.087 1.087 0 0 1 0-2.173z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.587a.67.67 0 0 1-.674-.667c0-.367.3-.667.667-.667.367 0 .666.3.666.667a.659.659 0 0 1-.66.667zM6 7.253a.67.67 0 0 1-.674-.666c0-.367.3-.667.667-.667.367 0 .667.3.667.667a.659.659 0 0 1-.66.667zM5.752 10.953a.495.495 0 0 1-.353-.146.503.503 0 0 1 0-.707l4.487-4.487a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707l-4.486 4.487a.484.484 0 0 1-.354.146z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCircle);
export default __webpack_public_path__ + "static/media/discount-circle.03b702379d0db790aa7903b67c5ae603.svg";
export { ForwardRef as ReactComponent };